
(function () {
  function getProxy() {
    return document.getElementById('cart-icon-bubble');
  }

  function getProxyBubbleHTML() {
    const proxy = getProxy();
    if (!proxy) return null;
    const bubble = proxy.querySelector('.cart-count-bubble');
    return bubble ? bubble.innerHTML : '';
  }

  function syncFiboliHeaderCartBubbles() {
    const bubbleHTML = getProxyBubbleHTML();
    if (bubbleHTML === null) return;

    document.querySelectorAll('[data-fiboli-cart-bubble]').forEach((bubble) => {
      bubble.innerHTML = bubbleHTML;
    });
  }

  function initCartBubbleSync() {
    const proxy = getProxy();
    if (!proxy) return;
    syncFiboliHeaderCartBubbles();
    const observer = new MutationObserver(() => {
      syncFiboliHeaderCartBubbles();
    });
    observer.observe(proxy, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', () => {
      syncFiboliHeaderCartBubbles();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartBubbleSync);
  } else {
    initCartBubbleSync();
  }
})();


